export enum IevpPillar {
    MaterialOfferings = 'MaterialOfferings',
    MeaningPurpose = 'MeaningPurpose',
    GrowthDevelopment = 'GrowthDevelopment',
    ConnectionCommunity = 'ConnectionCommunity',
}
